import React, { Component } from "react";
import PropTypes from "prop-types";
import { YearPicker, MonthPicker, DayPicker } from "react-dropdown-date";
import moment from "moment";
import InvalidFeedback from "../../../common/invalid_feedback";

class StartDateDropdown extends Component {
  constructor(props) {
    super(props);

    const startDate = props.initialStartDate && new Date(props.initialStartDate);

    // Copying props to state Anti-pattern solution
    // https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key
    this.state = {
      year: startDate && startDate.getFullYear().toString(),
      month: startDate && startDate.getMonth().toString(),
      day: startDate && startDate.getDate().toString()
    };
  }

  onStartDateChange = () => {
    const { year, month, day } = this.state;
    const { experience, onExperienceChange } = this.props;

    if (year && month && day) {
      onExperienceChange(
        event,
        experience,
        moment().year(year).month(month).date(day).format("YYYY-MM-DD")
      );
    }
  }

  onCurrentCheckChange = () => {
    const { experience, onExperienceChange } = this.props;
    onExperienceChange(event, experience, event.target.checked);
  }

  setFormControlClassName = () => {
    const { experience } = this.props;
    var className = "form-control";

    if (experience.errors.start_date) {
      className += " is-invalid";
    }

    return className;
  }

  render () {
    const { year, month, day } = this.state;
    const { index, experience } = this.props;

    return (
      <div className='col-12 col-md-6 mb-2 row no-gutters'>
        <div className='col-3 mr-2 mr-md-1 mr-lg-2'>
          <YearPicker
            defaultValue="年"
            start={1950}
            reverse
            required
            value={year}
            onChange={(year) => {
              this.setState({ year }, () => this.onStartDateChange());
            }}
            id={`career-experiences-attributes-${index}-start-year`}
            name="start_date"
            classes={this.setFormControlClassName()}
          />
          <InvalidFeedback errors={experience.errors.start_date} label='開始期間' />
        </div>
        <div className='col-3 mr-2 mr-md-1 mr-lg-2'>
          <MonthPicker
            defaultValue="月"
            numeric
            endYearGiven
            year={year}
            required
            value={month}
            onChange={(month) => {
              this.setState({ month }, () => this.onStartDateChange());
            }}
            id={`career-experiences-attributes-${index}-start-month`}
            name="start_date"
            classes={this.setFormControlClassName()}
          />
        </div>
        <div className='col-3 mr-md-2'>
          <DayPicker
            defaultValue="日"
            year={year}
            month={month}
            endYearGiven
            required
            value={day}
            onChange={(day) => {
              this.setState({ day }, () => this.onStartDateChange());
            }}
            id={`career-experiences-attributes-${index}-start-day`}
            name="start_date"
            classes={this.setFormControlClassName()}
          />
        </div>
        <div className='col-2 col-md-1 text-center form-control-v-center'>
          〜
        </div>

        <div className='col-12 mt-2'>
          <div className='form-check'>
            <input
              name='current'
              onChange={this.onCurrentCheckChange}
              className='form-check-input'
              type='checkbox'
              checked={experience.current}
              id={`career-experiences-attributes-${index}-current`}
            />
            現在働いている
          </div>
        </div>
      </div>
    );
  }
}

StartDateDropdown.propTypes = {
  initialStartDate: PropTypes.string.isRequired,
  experience: PropTypes.shape({
    errors: PropTypes.object.isRequired
  }).isRequired,
  index: PropTypes.number.isRequired,
  onExperienceChange: PropTypes.func.isRequired
};

export default StartDateDropdown;
